/**
 * Config limits for letter words pages.
 */
export const WORD_LIST_LIMITS = {
	LENGTH_MIN: 2,
	LENGTH_MAX: 20,
};
